export class MyAwardsFilter {
    awardsPageId : string;
    searchTerm:string;
    salesStartDate: string;
    salesEndDate: string;
    claimsStartDate: string;
    claimsEndDate: string;
}